import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ApplicationConfigModule } from 'src/app/core/application-config/application-config.module';

import { LocaleModule } from 'src/app/core/locale/locale.module';
import { RoutingModule } from 'src/app/core/routing/routing.module';
import { SwapLanguageComponent } from './swap-language.component';

@NgModule({
	declarations: [SwapLanguageComponent],
	exports: [SwapLanguageComponent],
	imports: [CommonModule, RoutingModule, LocaleModule, ApplicationConfigModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SwapLanguageModule {}
